/* eslint-disable no-underscore-dangle */
import ApiManager from '../api/crud-manager';

const getChildrenProperties = parentId => {
  const api = new ApiManager();
  const url = `/api/v2/page/${parentId}/childproperties?items=1000`;

  return api
    .get(url)
    .then(data => data)
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('getChildrenProperties request failed', error);
      return null;
    });
};

const uniqArray = array => array.filter((a, b) => array.indexOf(a) === b);

class OverviewPageFilters {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="OverviewPageFilters"]'),
      ...options
    };
  }

  static renderSelect(sortedfilterData, filterInput) {
    const params = new URLSearchParams(window.location.search);
    const select = document.createElement('select');
    select.classList.add('form-control');
    select.options.add(new Option(filterInput.dataset.firstOptionResource, '', false, false));
    select.options[0].setAttribute('disabled', '');
    select.options[0].setAttribute('hidden', '');

    let arrSortedfilterData = [];

    sortedfilterData.forEach(item => {
      const splitValues = item.split('|');
      arrSortedfilterData = arrSortedfilterData.concat(splitValues);
    });

    // Filter out unique values
    arrSortedfilterData = arrSortedfilterData.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    arrSortedfilterData.forEach(filterItem => {
      const isSelected = params.get(filterInput.dataset.name) === filterItem; // check if parameter is in url to add selected state
      select.options.add(new Option(filterItem, filterItem, isSelected, isSelected)); // create option element for filter select
    });

    filterInput.appendChild(select);

    // set event listner to change filter parameter
    filterInput.addEventListener('change', e => {
      params.set(filterInput.dataset.name, e.target.value);

      // reload browser with new parameters
      window.location.search = params.toString();
    });
  }

  static renderRadiobuttons(sortedfilterData, filterInput, filterName) {
    const params = new URLSearchParams(window.location.search);

    let arrSortedfilterData = [];

    sortedfilterData.forEach(item => {
      const splitValues = item.split('|');
      arrSortedfilterData = arrSortedfilterData.concat(splitValues);
    });

    // Filter out unique values
    arrSortedfilterData = arrSortedfilterData.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    arrSortedfilterData.forEach((filterItem, index) => {
      const isSelected = params.get(filterInput.dataset.name) === filterItem; // check if parameter is in url to add selected state

      // create and append checkbox
      const element = `
      <div class="form-check">
        <input name="${filterName}" id="${filterName}_${index}" value="${filterItem}" type="radio" ${
        isSelected ? 'checked' : ''
      }> 
        <label for="${filterName}_${index}">${filterItem}</label>
      </div>
      `;
      filterInput.insertAdjacentHTML('beforeend', element);

      // set event listner to change filter parameter
      filterInput.addEventListener('change', e => {
        params.set(filterInput.dataset.name, e.target.value);

        // reload browser with new parameters
        window.location.search = params.toString();
      });
    });
  }

  static renderCheckboxes(sortedfilterData, filterInput, filterName) {
    const params = new URLSearchParams(window.location.search);

    let arrSortedfilterData = [];

    sortedfilterData.forEach(item => {
      const splitValues = item.split('|');
      arrSortedfilterData = arrSortedfilterData.concat(splitValues);
    });

    // Filter out unique values
    arrSortedfilterData = arrSortedfilterData.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    arrSortedfilterData.forEach((filterItem, index) => {
      const filterdParams = params.get(filterName);
      const isSelected = filterdParams && filterdParams.split(',').includes(filterItem); // check if parameter is in url to add checked state

      // create and append checkbox
      const element = `
      <div class="form-check">
        <input name="${filterName}" id="${filterName}_${index}" value="${filterItem}" type="checkbox" ${
        isSelected ? 'checked' : ''
      }> 
        <label for="${filterName}_${index}">${filterItem}</label>
      </div>
      `;
      filterInput.insertAdjacentHTML('beforeend', element);

      // set event listner to change filter parameter
      const checkbox = document.querySelector(`#${filterName}_${index}`);
      checkbox.addEventListener('change', e => {
        let { value } = e.target;
        const filterdValues = filterdParams && filterdParams.split(',');

        // check if the parameter already has the value, then put it in the array or remove the value from the array
        if (filterdValues) {
          if (filterdValues.includes(value)) {
            const filterdValueIndex = filterdValues.indexOf(value);
            if (filterdValueIndex > -1) {
              filterdValues.splice(filterdValueIndex, 1);
            }
          } else {
            filterdValues.push(value);
          }
          value = filterdValues.join(',');
        }

        // Set parameter only if value has a value
        if (value) {
          params.set(filterName, value);
        } else {
          params.delete(filterName);
        }

        // reload browser with new parameters
        window.location.search = params.toString();
      });
    });
  }

  static renderButtons(sortedfilterData, filterInput, filterName) {
    const params = new URLSearchParams(window.location.search);

    let arrSortedfilterData = [];

    sortedfilterData.forEach(item => {
      const splitValues = item.split('|');
      arrSortedfilterData = arrSortedfilterData.concat(splitValues);
    });

    // Filter out unique values
    arrSortedfilterData = arrSortedfilterData.filter(
      (value, index, self) => self.indexOf(value) === index
    );

    arrSortedfilterData.forEach((filterItem, index) => {
      const isSelected = params.get(filterInput.dataset.name) === filterItem; // check if parameter is in url to add selected state

      // create and append checkbox
      const element = `
      <div class="c-filterbutton">
        <input name="${filterName}" id="${filterName}_${index}" value="${filterItem}" type="radio" ${
        isSelected ? 'checked' : ''
      }> 
        <label for="${filterName}_${index}">${filterItem}</label>
      </div>
      `;
      filterInput.insertAdjacentHTML('beforeend', element);

      // set event listner to change filter parameter
      filterInput.addEventListener('change', e => {
        params.set(filterInput.dataset.name, e.target.value);

        // reload browser with new parameters
        window.location.search = params.toString();
      });
    });
  }

  static filterGivenData(filterName, data) {
    const filterData = data
      .filter(item => item.name === filterName)
      .map(item => item.value)
      .filter(item => item); // make array of filter values in element
    return uniqArray(filterData).sort();
  }

  renderFilterInputs(jsonData) {
    const { module } = this.config;
    const FilterItems = module.querySelectorAll('[data-child-module="OverviewPageFilters__Item"]');
    let activeFilters = 0;

    if (FilterItems.length) {
      FilterItems.forEach(element => {
        const filterInputSelect = element.querySelector(
          '[data-child-module="OverviewPageFilters__InputSelect"]'
        );
        const filterInputRadio = element.querySelector(
          '[data-child-module="OverviewPageFilters__InputRadio"]'
        );
        const filterInputCheckbox = element.querySelector(
          '[data-child-module="OverviewPageFilters__InputCheckbox"]'
        );
        const filterInputButtons = element.querySelector(
          '[data-child-module="OverviewPageFilters__InputButtons"]'
        );

        if (filterInputSelect) {
          const filteredData = OverviewPageFilters.filterGivenData(
            filterInputSelect.dataset.name,
            jsonData
          );
          if (filteredData.length > 0) {
            OverviewPageFilters.renderSelect(filteredData, filterInputSelect);
          }
          activeFilters += 1;
        }
        if (filterInputRadio) {
          const filteredData = OverviewPageFilters.filterGivenData(
            filterInputRadio.dataset.name,
            jsonData
          );
          if (filteredData.length > 0) {
            OverviewPageFilters.renderRadiobuttons(filteredData, filterInputRadio);
          }
          activeFilters += 1;
        }
        if (filterInputCheckbox) {
          const filteredData = OverviewPageFilters.filterGivenData(
            filterInputCheckbox.dataset.name,
            jsonData
          );
          if (filteredData.length > 0) {
            OverviewPageFilters.renderCheckboxes(
              filteredData,
              filterInputCheckbox,
              filterInputCheckbox.dataset.name
            );
          }
          activeFilters += 1;
        }

        if (filterInputButtons) {
          const filteredData = OverviewPageFilters.filterGivenData(
            filterInputButtons.dataset.name,
            jsonData
          );
          if (filteredData.length > 0) {
            OverviewPageFilters.renderButtons(filteredData, filterInputButtons);
          }
          activeFilters += 1;
        }
      });
    }

    if (activeFilters > 0) {
      module.removeAttribute('style');
    }
  }

  init() {
    const { module } = this.config;

    if (!module) {
      return;
    }

    const { overviewpageId } = module.dataset;
    const pageId = parseInt(overviewpageId, 10);

    getChildrenProperties(pageId).then(jsonData => {
      if (!jsonData || !jsonData._embedded || !jsonData._embedded.childproperties) return;
      const data = jsonData._embedded.childproperties;
      this.renderFilterInputs(data);
    });
  }
}

export default OverviewPageFilters;
